import { useEffect, useState } from "react";
import PaginationFragment from "../../../../../components/fragment/pagination/PaginationFragment";
import {
  RazorDateTime,
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
} from "../../../../../components/razor-reuse";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import StatusFragment from "../../../../../components/fragment/status/StatusFragment";
import RootState from "../../../../../redux/type";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerSuspensionHistory } from "../../../../../redux/customer";
import { ALL_ICONS } from "../../../../../assets/icons/AllIcons";

export default function SuspensionHistory() {
  const dispatch = useDispatch();
  const { loading_transaction, customer_suspension } = useSelector(
    (state: RootState) => state.customer
  );
  const [page, setCurrentPage] = useState(1); /// Pagination
  const [modal, setModal] = useState({
    visible: false,
    reason: "",
  });

  const headerList = [
    "Date/Time",
    "Admin Name",
    "Status Change",
    "Reason for Suspension",
  ];

  // Get customer transaction endpoint call
  const cust_id = localStorage?.getItem("cors_key") || "";
  useEffect(() => {
    let obj = {
      id: cust_id,
      page,
    };
    dispatch(getCustomerSuspensionHistory(obj) as any);
  }, [page, cust_id]);

  return (
    <div className="transaction-index-wrap-box-smartsend">
      {customer_suspension?.data?.length < 1 ? (
        <section className="size-full h-[calc(100vh-24rem)] grid place-content-center">
          <figure className="size-fit mx-auto space-y-[8px]">
            {ALL_ICONS.receipt_warning}
          </figure>
          <p className="text-[12px] text-gray-02">
            No Suspension records found
          </p>
        </section>
      ) : (
        <>
          {/* filter section end */}
          <div className="table-section-box">
            <RazorTable headerList={headerList}>
              {customer_suspension?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    key={idx}
                    one={
                      chi?.banned_at ? (
                        <RazorDateTime
                          hideAgo
                          hideTime={true}
                          date={chi?.banned_at}
                        />
                      ) : (
                        "---"
                      )
                    }
                    two={`${chi?.performed_by?.first_name || "---"} ${
                      chi?.performed_by?.last_name || "---"
                    }`}
                    three={
                      <StatusFragment
                        text={chi?.restriction_type || ""}
                        className={
                          chi?.restriction_type === "suspend"
                            ? "failed"
                            : chi?.restriction_type === "unsuspend"
                            ? "success"
                            : ""
                        }
                      />
                    }
                    onRowClick={() => {
                      setModal({ visible: true, reason: chi?.description });
                    }}
                    four={
                      <>
                        {RazorTextTrim(chi?.description || "---", 38)}{" "}
                        <span className="underline text-[12px] !text-blue-01">
                          view more
                        </span>
                      </>
                    }
                    loading={loading_transaction}
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={customer_suspension?.meta?.current_page || 1}
            perPage={customer_suspension?.meta?.per_page}
            totalPage={customer_suspension?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading_transaction}
          />
        </>
      )}

      <ReuseModal
        classname="!bg-black/20"
        visible={modal?.visible}
        title="Reason for Suspension"
        onClose={() => {
          setModal({ reason: "", visible: false });
        }}
        hideBtn
      >
        <p className="">{modal?.reason}</p>
      </ReuseModal>
    </div>
  );
}
